import {apolloPlatformAxiosInstance as axiosInstance} from './apolloPlatformAxiosInstance';

/**
 * Sphere Admin API
 */

export const apiGetAdmin = async (endpoint: string) => {
  return await axiosInstance.get(endpoint);
};

export const apiPostAdmin = async (endpoint: string, data?: any) => {
  return await axiosInstance.post(endpoint, data);
};

export const apiDeleteAdmin = async (endpoint: string) => {
  return await axiosInstance.delete(endpoint);
};
